import { FilterMatchMode } from "primereact/api";

export class EstadoPatrimonial {

    model = {
        id: {
            value: null, export: true, table: false
        },
        composicion_capital: {
            value: null,
            export: true,
            header: 'Composición del Capital',
            table: true,
            sort: false,
            filter: false,
            headerStyle: { width: '8%', minWidth: '5rem' }
        },
        nombre_accionista: {
            value: '',
            export: true,
            header: 'Nombre del accionista o socio',
            table: true,
            sort: false,
            headerStyle: { width: '30%', minWidth: '20rem' },
            filterPlaceholder: 'Buscar',
            filterField: 'nombre_accionista',
            matchMode: FilterMatchMode.CONTAINS,
            required: 'Campo requerido',
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 3 caracteres',
            max: 300,
            min: 3,
        },
        tipo_identificacion: {
            value: null,
            export: false,
            header: 'Tipo de Identificación',
            table: false,
            required: 'Debe seleccionar un tipo de identificación'
        },
        identificacion: {
            value: '',
            export: true,
            header: 'Número de identificación',
            table: true,
            sort: false,
            headerStyle: { width: '20%', minWidth: '15rem' },
            filterPlaceholder: 'Buscar',
            filterField: 'identificacion',
            matchMode: FilterMatchMode.CONTAINS,
            required: 'Campo requerido',
            maxLength: 'Máximo 50 caracteres',
            max: 50,
        },
        participacion: {
            value: null,
            export: true,
            header: '% Participación',
            table: true,
            sort: false,
            filter: false,
            headerStyle: { width: '15%', minWidth: '10rem' },
            max: 100,
            min: 10,
            required: 'Porcentaje requerido'
        },
        fecha_nacimiento: {
            value: null,
            export: true,
            header: 'Fecha Nacimiento',
            table: false, // Se habilitará condicionalmente en la vista
            isDate: true,
            sort: true,
            headerStyle: { width: '15%', minWidth: '10rem' },
            body: (rowData) => {
                if (!rowData.fecha_nacimiento) return null;
                // Forzar que la fecha se interprete a medianoche en la hora local del navegador
                return new Date(rowData.fecha_nacimiento + 'T00:00:00').toLocaleDateString();
            },
            required: 'Fecha de nacimiento requerida'
        }
    }
    optionLabel = 'nombre';
}